export const CATEGORY_MAPPING = [
  { id: "agentacknowledgement", value: "Agent Acknowledgement" },
  { id: "alereceipt", value: "ALE Receipt" },
  { id: "certifiedpolicy", value: "Certified Policy" },
  { id: "estimate", value: "Estimate" },
  { id: "photos", value: "Photos" },
  { id: "receipt", value: "Receipt" },
  { id: "receiptinvoice", value: "Receipt/Invoice" },
  { id: "title", value: "Title" },
  { id: "fnol", value: "FNOL" },
];

export const UPLOAD_FILE_TYPES = ["image/jpeg", "image/png", "application/pdf"];

export const DOCUMENT_CATEGORY = [
  {
    id: "None",
    displayName: "Select",
    docTypeDefault: "NA",
    nuxeoValue: "None",
    selected: true,
  },
  {
    id: "categ-estimate",
    displayName: "Estimate",
    docTypeDefault: "estimate",
    nuxeoValue: "estimatesandrelatedphotos-1",
    selected: false,
  },
  {
    id: "categ-photos",
    displayName: "Photos",
    docTypeDefault: "estimate",
    nuxeoValue: "estimatesandrelatedphotos-2",
    selected: false,
  },
  {
    id: "categ-reports",
    displayName: "Reports",
    docTypeDefault: "policefirereport",
    nuxeoValue: "reports-1",
    selected: false,
  },
];

export const DOCUMENT_TYPE = [
  { id: "None", displayName: "Select", selected: true },
  { id: "estimate", displayName: "Estimate", selected: false },
  { id: "photos", displayName: "Photos", selected: false },
  { id: "policefirereport", displayName: "Police Reports", selected: false },
];

export const UPLOAD_SUCCESS_MSG =
  "Documents uploaded Successfully. You can upload more documents or close this dialog.";
export const UPLOAD_FAILURE_MSG =
  "Documents did not upload correctly. Please retry uploading your file or close this dialog. ";
export const UPLOAD_MISSING_SELECT_MSG =
  "Select all required fields and then click Upload Document(s) button.";
export const UPLOAD_DIALOG_WARNING =
  "Are you sure you would like to cancel uploading all documents?";

export const MAX_ALLOWED_PHOTO_SIZE_IN_MB = 10;
export const FILE_TYPE_ERROR = "This file type is not allowed.";
export const FILE_SIZE_ERROR =
  "This photo does not meet the size requirements.";

export const uploadPhotosBtn = "Upload photos";
export const goToClaimsBtn = "Go to claims";
